import axios from '@/util/basehttp';
import qs from 'qs';


const pre = "/choicePlan/base"

const choicePlan = {
  choicePlanList(pageSize, limit, name) {
    return axios.get(pre + `/choicePlanList`, {
      params:
        {
          pageSize: pageSize,
          limit: limit,
          name: name,
        }
    });
  },
  getChoicePlanInfo(id) {
    return axios.get(pre + `/getChoicePlanInfo`, {params: {id: id}});
  },
  saveChoicePlan(params) {
    return axios.post(pre + `/saveChoicePlan`, qs.stringify(params));
  },
  deleteChoicePlan(id) {
    return axios.post(pre + `/deleteChoicePlan`, qs.stringify({id: id}));
  },
}
export default choicePlan;



// WEBPACK FOOTER //
// ./src/api/config/choiceConfig.js